import { render, staticRenderFns } from "./GroupChange.vue?vue&type=template&id=f17621d8&"
import script from "./GroupChange.vue?vue&type=script&lang=js&"
export * from "./GroupChange.vue?vue&type=script&lang=js&"
import style0 from "./GroupChange.vue?vue&type=style&index=0&id=f17621d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports